export default {"src":"/_next/static/image/public/images/ic_percentage_offer_green.b7efd92d3c6191ee9882ffe3bf8abccc.svg","height":24,"width":24};